export default __webpack_public_path__ + "images/front-side.ec7291eba7782350aed06474ea92299e.svg";